import { tmxApiCall } from './index'

// Utility
import logger from '../utility/loggerUtil'
import session from '../utility/sessionUtil'
import gps from '../utility/gpsUtil'

export default {
  /**
   * Gets information to complete a new loan origination.
   * @param {String} applicationId - The identifier for the loan application.
   * @returns {Promise<{appraisalId: Number, customerId: String, maxLoanAmount: Number, minLoanAmount: Number, productId: Number, loanTypeCode: Number, locationId: Number, locationBrand: String, storeId: Number, loanValidations: Object}>}
   */
  async getOriginationInfo (applicationId) {
    logger.info('Started to get loan origination info.')

    return tmxApiCall('get', '/originationInfo', {
      headers: {
        'x-mobile-app-id-token': session.getIdToken()
      },
      params: {
        applicationId
      }
    })
  },

  /**
   * Kicks off the Loan Originate process.
   * @param {String|Number} applicationId - The application ID associated with new loan.
   * @param {String} appraisalId - The appraisal ID associated with the new loan request.
   * @param {Number} disburseCardId - The card ID to disburse funds to. Only used for push to card disbursement type.
   * @param {Number} disbursementAmount - The amount of money to disburse to the customer.
   * @param {Number} disbursementType - The method to use for disbursing funds.
   * @param {String} loanTypeCode - The type of loan (personal or title).
   * @param {String} locationId - The ID of the location associated with the origination (currently mobile money location ID).
   * @param {String} locationBrand - The brand of the location associated with the origination.
   * @param {String|Number} productId - The product ID associated with the new loan.
   * @param {String|Number} storeId - The store ID associated with the new loan.
   */
  async originate (applicationId, appraisalId, disburseCardId, disbursementAmount, disbursementType, loanTypeCode, locationId, locationBrand, productId, storeId) {
    logger.info('Started loan origination call.')
    return tmxApiCall('post', '/loanOriginate', {
      applicationId,
      appraisalId,
      disburseCardId,
      disbursementAmount,
      disbursementType,
      loanTypeCode,
      locationId,
      locationBrand,
      productId,
      storeId,
      timeZone: gps.getTimezone()
    })
  },

  /**
   * Gets the response from the Vergent LMS loan origination request.
   * @param {String} messageKey - The key associated with the loan origination.
   * @returns {Promise<{messageKey: String, expirationDate: Number, messageData: Object}}>}
   */
  async getOriginationStatus (messageKey) {
    logger.info('Started get loan origination status call.')
    return tmxApiCall('get', '/loanOriginate', {
      params: {
        messageKey
      }
    })
  },

  /**
   * Updates an appraisals status to put a customer in a queue to be called by a representative.
   * @param {String} appraisalId - The identifier of an appraisal.
   */
  async addToPhoneQueue (appraisalId) {
    logger.info('Started put add to phone queue call.')
    return tmxApiCall('put', '/appraisalStatus', {
      appraisalId
    })
  }
}
